var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Point"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 11.0987C4 6.45646 7.74148 2.7959 12.2353 2.7959C16.7291 2.7959 20.4706 6.45646 20.4706 11.0987C20.4706 15.453 17.9596 20.5673 13.9089 22.429C13.3797 22.6711 12.8104 22.7959 12.2353 22.7959C11.6602 22.7959 11.0909 22.6711 10.5617 22.429C6.51097 20.5673 4 15.4542 4 11.0987ZM12.2353 4.51018C8.51294 4.51018 5.59393 7.51589 5.59393 11.0987C5.59393 14.9022 7.83074 19.3102 11.1886 20.853C11.5198 21.0038 11.8757 21.0815 12.2353 21.0815C12.5949 21.0815 12.9508 21.0038 13.282 20.853C16.6398 19.3102 18.8767 14.9022 18.8767 11.0987C18.8767 7.51703 15.9576 4.51018 12.2353 4.51018Z",
    fill: "#81C23D",
    stroke: "#81C23D",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1 (Stroke)",
    d: "M12.2352 12.9458C13.2927 12.9458 14.1499 12.0886 14.1499 11.0311C14.1499 9.97366 13.2927 9.11641 12.2352 9.11641C11.1778 9.11641 10.3205 9.97366 10.3205 11.0311C10.3205 12.0886 11.1778 12.9458 12.2352 12.9458ZM15.6146 11.0311C15.6146 12.8975 14.1016 14.4105 12.2352 14.4105C10.3688 14.4105 8.85581 12.8975 8.85581 11.0311C8.85581 9.16472 10.3688 7.65171 12.2352 7.65171C14.1016 7.65171 15.6146 9.16472 15.6146 11.0311Z",
    fill: "#81C23D",
    stroke: "#81C23D",
    strokeWidth: 0.3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/Point.24b491b4d1a3be1bed85c45b2b57f6d1.svg";
export { ForwardRef as ReactComponent };